export default __webpack_public_path__ + "static/media/emoji_love.35c8681e.png";